.c12dc8 {
  outline: 1px dotted #212121;
  outline: 5px auto -webkit-focus-ring-color;
}
